import React from 'react';
import { NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import styles from './navbarDropdown.module.scss';
import { OptionType } from '../../form/CustomSelectors/SearchesSelect';
import { ReactComponent as AngleDown } from '../../icons/angleDown.svg';

type NavbarDropdownProps = {
  label: string;
  options: OptionType[];
  onSelect: () => void;
};

export const NavbarDropdown = ({
  label,
  options,
  onSelect,
}: NavbarDropdownProps) => {
  const formatedTitle = () => (
    <React.Fragment>
      {label}
      <AngleDown />
    </React.Fragment>
  );
  return (
    <NavDropdown
      title={formatedTitle()}
      id={`nav-dropdown-${label}`}
      className={classnames(styles.dropdownMenu)}
      onSelect={onSelect}
    >
      {options.map((option) => (
        <NavDropdown.Item key={option.value} as={Link} to={option.to}>
          {option.label}
        </NavDropdown.Item>
      ))}
    </NavDropdown>
  );
};
